import { maisIntegridade, mapa, sisbi } from "../../assets/images";
import EmblaCarousel from "../../components/carousel/EmblaCarousel";
import Footer from "../../components/footer";
import {
  BannerText,
  BannerWrapper,
  BoxImageContainer,
  BoxImageMaisIntegridade,
  BoxImageMapa,
  BoxImageSisbi,
  BoxTextContainer,
  ButtonContatos,
  ContatosESelosContainer,
  GridContainer,
  HomeContainer,
  InfoCard,
  InfoContainer,
  InfoText,
  InfoTitle,
  ProductsContainer,
  ProductsTitle,
} from "./styles";
import { EmblaOptionsType } from "embla-carousel";

const OPTIONS: EmblaOptionsType = {};
const SLIDE_COUNT = 5;
const SLIDES = Array.from(Array(SLIDE_COUNT).keys());

const infoCards = [
  {
    title: "Tradição e qualidade Suprema",
    texts: [
      "Compromisso com o autêntico Jerked Beef, respeitando processos artesanais e rigorosos padrões de qualidade.",
      "Produção com cortes selecionados, garantindo sabor e textura superiores.",
    ],
  },
  {
    title: "Produtos para todo\no Brasil",
    texts: [
      "Linha completa de Jerked Beef para diferentes necessidades do mercado.",
      "Distribuição eficiente para atender revendedores de todo o país.",
    ],
  },
  {
    title: "Benefícios para Revendedores",
    texts: [
      "Alta demanda e excelente margem de lucro.",
      "Suporte comercial e materiais promocionais exclusivos.",
    ],
  },
  {
    title: "Produção sustentável e certificada",
    texts: [
      "Processos que valorizam a sustentabilidade e o aproveitamento total da carne.",
      "Certificações que garantem segurança alimentar e excelência no produto, incluindo o CISBI, que assegura padrões sanitários rigorosos para exportação e comercialização no Brasil.",
    ],
  },
];

const Home = () => {
  return (
    <HomeContainer>
      <BannerWrapper>
        <BannerText>
          O autêntico
          <br />
          sabor da tradição,
          <br />
          pronto para
          <br />
          o seu negócio.
          <br />
        </BannerText>
      </BannerWrapper>

      <InfoContainer>
        <GridContainer>
          {infoCards.map((card, index) => (
            <InfoCard key={index}>
              <InfoTitle>{card.title}</InfoTitle>
              {card.texts.map((text, i) => (
                <InfoText key={i}>{text}</InfoText>
              ))}
            </InfoCard>
          ))}
        </GridContainer>
      </InfoContainer>

      <ProductsContainer>
        <ProductsTitle>Nossos Produtos</ProductsTitle>
        <EmblaCarousel slides={SLIDES} options={OPTIONS} />
      </ProductsContainer>

      <ContatosESelosContainer>
        <BoxTextContainer>
          <div>
            <h2>Vamos fazer negócios?</h2>
            <p>Fale com um especialista</p>
          </div>
          <ButtonContatos
            onClick={() => {
              window.location.href = "/contact-us";
            }}
          >
            CONTATO
          </ButtonContatos>
        </BoxTextContainer>
        <BoxImageContainer>
          <BoxImageSisbi src={sisbi} alt="SISBI" />
          <BoxImageMaisIntegridade src={maisIntegridade} />
          <BoxImageMapa src={mapa} alt="Mapa" />
        </BoxImageContainer>
      </ContatosESelosContainer>

      <Footer />
    </HomeContainer>
  );
};
export default Home;
